"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopActionsDropdown = void 0;
// tslint:disable:max-classes-per-file
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const touch_1 = require("../../utils/touch");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const DesktopActionsButton_1 = __importDefault(require("./DesktopActionsButton"));
const DesktopActionsDropdown = (props) => {
    const [open, setOpen] = react_1.useState(false);
    const [mouseIsOver, setMouseIsOver] = react_1.useState(false);
    const [timeoutHandler, setTimeoutHandler] = react_1.useState(null);
    const ref = react_1.useRef(null);
    const toggleOpen = () => setOpen(true);
    const close = () => setOpen(false);
    const mouseLeave = () => {
        if (props.openOnHover && !touch_1.isTouchCapable()) {
            setMouseIsOver(false);
            if (timeoutHandler) {
                clearTimeout(timeoutHandler);
            }
            const timeout = setTimeout(() => {
                if (!mouseIsOver) {
                    setOpen(false);
                }
            }, props.autoCloseTimeout ? props.autoCloseTimeout : 1000);
            setTimeoutHandler(Number(timeout));
        }
    };
    const setMouseIsHovering = () => {
        setMouseIsOver(true);
    };
    const click = (e, action) => {
        e.stopPropagation();
        if (typeof action.action === 'function') {
            action.action();
        }
        close();
    };
    const mouseOver = () => {
        if (!touch_1.isTouchCapable()) {
            setMouseIsOver(true);
            // tslint:disable-next-line:no-unused-expression
            props.openOnHover && toggleOpen();
        }
    };
    const handleClickOutside = (e) => {
        e.stopPropagation();
        if (ref.current && !ref.current.contains(e.target)) {
            close();
        }
    };
    const buttonOnClick = (e) => {
        e.stopPropagation();
        if (props.closeOnReClick) {
            setOpen((old) => !old);
        }
        else {
            toggleOpen();
        }
    };
    return (React.createElement("div", null,
        open && React.createElement("div", { className: "desktop-actions-overlay-div", onClick: handleClickOutside }),
        React.createElement("div", { className: "desktop-actions-dropdown", ref: ref },
            React.createElement(DesktopActionsButton_1.default, { onClick: buttonOnClick, onMouseOver: mouseOver, onMouseLeave: mouseLeave, hover: props.hover, active: open, useShareIcon: props.useShareIcon, color: props.color }),
            open && (React.createElement("ul", null, props.actions.map((action) => {
                if (action.type === 'link-external') {
                    return (React.createElement("li", { key: action.label },
                        React.createElement("a", { href: action.href, target: "_blank" },
                            React.createElement("p", { className: 'label-overflow' }, action.label),
                            React.createElement(Icon_1.default, { className: 'dropdown-link-icon', icon: 'open_in_new_blue', size: 14 }))));
                }
                else if (action.type === 'link-internal') {
                    return (React.createElement("li", { key: action.label },
                        React.createElement(react_router_dom_1.Link, { to: { pathname: action.href }, target: action.target },
                            React.createElement("p", { className: 'label-overflow' }, action.label),
                            React.createElement(Icon_1.default, { className: 'dropdown-link-icon', icon: 'open_in_new_blue', size: 14 }))));
                }
                else {
                    const classNames = classnames_1.default({ disabled: action.disabled });
                    return (React.createElement("li", { key: action.label },
                        React.createElement("button", { className: classNames, onClick: action.disabled ? undefined : (e) => click(e, action), onMouseOver: setMouseIsHovering, onMouseLeave: mouseLeave },
                            action.label && React.createElement("p", { className: 'label-overflow' }, action.label),
                            React.isValidElement(action.action) && action.action,
                            action.icon)));
                }
            }))))));
};
exports.DesktopActionsDropdown = DesktopActionsDropdown;
//# sourceMappingURL=DesktopActionsDropdown.js.map